export function getCrypto() {
  if (typeof window === 'undefined' || typeof window.crypto === 'undefined') {
    throw new Error('Crypto API is not available in the current environment.');
  }
  return window.crypto;
}